import {
  UPDATE_INS_USER_INFO,
  DELETE_INS_USER_INFO,
  ADD_INS_USER_INFO,
  CLEAR_INS_USER_INFO
} from "@/store/constants/ins_user_info_types";
export default {
  [UPDATE_INS_USER_INFO](state: any, payload: any) {
    // 更新已经存在的账号信息
    const { user_info, user_id } = payload;
    const findUserIndex = state.ins_user_info_list.findIndex((user: any) => {
      return user_id === user.user_id;
    });
    if (findUserIndex > -1) {
      // had user
      const findUserInfo = state.ins_user_info_list[findUserIndex];
      const updateUserInfo = { ...findUserInfo, ...user_info };
      state.ins_user_info_list.splice(findUserIndex, 1, updateUserInfo);
    } else {
      return Promise.reject("Not find exist user id");
    }
  },
  [ADD_INS_USER_INFO](state: any, payload: any) {
    // 添加账号，可能账号已经存在，二次登陆
    const { user_info, user_id, user_type } = payload;
    console.log("ADD_INS_USER_INFO", user_type);
    const findUserIndex = state.ins_user_info_list.findIndex((user: any) => {
      return user_id === user.user_id;
    });
    if (findUserIndex > -1) {
      // 如果当前是Login账号，替换，否则不变
      if (user_type === "login") {
        // had user
        const findUserInfo = state.ins_user_info_list[findUserIndex];
        const updateUserInfo = { ...findUserInfo, ...user_info };
        state.ins_user_info_list.splice(findUserIndex, 1, updateUserInfo);
      }
    } else {
      // not same user:
      state.ins_user_info_list.unshift(user_info);
    }
  },
  [DELETE_INS_USER_INFO](state: any, payload: string) {
    const findUserIndex = state.ins_user_info_list.findIndex((user: any) => {
      return payload === user.user_id;
    });
    if (findUserIndex > -1) {
      state.ins_user_info_list.splice(findUserIndex, 1);
    } else {
      return Promise.reject("Not find exist user id");
    }
  },
  [CLEAR_INS_USER_INFO](state: any, payload: string) {
    state.ins_user_info_list = [];
  }
};
